import { StateTime } from '../../../WidgetBlocks/types';
import { TypeKeys } from '../../widgetblock/actions/types';

interface SetTimeForAllWidgetBlocksAction {
    type: TypeKeys.SET_TIME_FOR_ALL_WIDGET_BLOCKS;
    payload: StateTime;
}

const setTimeForAllWidgetBlocks = (iso8601: string, timezone: string): SetTimeForAllWidgetBlocksAction => ({
    type: TypeKeys.SET_TIME_FOR_ALL_WIDGET_BLOCKS,
    payload: {
        iso8601,
        timezone,
    },
});

export default setTimeForAllWidgetBlocks;
export { SetTimeForAllWidgetBlocksAction };
